(() => {
  const initSliders = () => {
    const slideshows = document.querySelectorAll(".slideshow__swiper");

    slideshows.forEach((slideshow) => {
      if (slideshow.classList.contains("swiper-initialized")) return;

      const slides = slideshow.querySelectorAll(".swiper-slide");
      const slideCount = slides.length;
      const autoplay = slideshow.getAttribute("data-autoplay") === "true";

      if (slideCount <= 1) {
        slideshow.classList.add("slideshow__swiper--single-slide");
        return;
      }

      const slideshowSwiper = new Swiper(slideshow, {
        navigation: {
          nextEl: slideshow.querySelector(".swiper-button-next"),
          prevEl: slideshow.querySelector(".swiper-button-prev"),
        },
        loop: true,
        autoHeight: false,
        allowTouchMove: true,
        autoplay: autoplay
          ? {
              delay: Number(slides[0].dataset.swiperAutoplay || 5000),
              disableOnInteraction: false,
            }
          : false,
      });

      slideshow.classList.add("slideshow__swiper--multiple-slides");

      if (autoplay) {
        slideshow.addEventListener("mouseenter", () => {
          slideshowSwiper.autoplay.pause();
        });

        slideshow.addEventListener("mouseleave", () => {
          slideshowSwiper.autoplay.run();
        });
      }
    });
  };

  initSliders();

  document.addEventListener("shopify:section:load", function () {
    initSliders();
  });
})();